import { Box, Link } from '@mui/material'
import { useState } from 'react'
import { Button, Image, InformationModal } from 'utoniq-ui'
import { Icons } from 'utoniq-ui'

import {
  GalleryPostFragment,
  Maybe,
  PostType,
} from '@/clients/utoniq-core/schema'
import { SideMenuProps } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { useSettingUserInfoModal } from '@/core/membership/useSettingUserInfoModal'

import { ThumbnailImage } from './Thumbnaillmage'

export type GalleryListItemProps = {
  post: GalleryPostFragment
  user?: Maybe<SideMenuProps['user']>
}

export const GalleryListItem = ({ post, user }: GalleryListItemProps) => {
  const { routerPages, generatePath } = useRouter()
  const [open, setOpen] = useState<boolean>(false)
  const isPersonalInfoRequired =
    user?.isMembershipPersonalInformationRequired &&
    post.isPremium &&
    post.artist.patron?.isPersonalInformationRequired
  const { showModal } = useSettingUserInfoModal()
  const imageUri =
    post.resources?.[0]?.mediumUri ?? post.resources?.[0]?.uri ?? ''
  // ユーザーが加入しているメンバーシップよりも上位プランであるかどうか
  const isGraterPlan = !post.isAccessible && post.planId
  const { t } = useTranslation('postDetail')
  return (
    <>
      {post.isAccessible ? (
        <Link
          href={
            !isPersonalInfoRequired
              ? generatePath(routerPages.PostDetail, {
                  postId: post.id,
                })
              : undefined
          }
        >
          <Box
            sx={{
              width: '99%',
              height: '98%',
              aspectRatio: '1/1',
              position: 'relative',
            }}
            onClick={() => isPersonalInfoRequired && showModal()}
          >
            {post.resourceType === PostType.Image ? (
              <Image
                src={imageUri}
                style={{
                  width: '99%',
                  height: '98%',
                  objectFit: 'cover',
                  borderRadius: '8px',
                }}
              />
            ) : (
              <>
                <ThumbnailImage
                  src={post.videoThumbnail?.mediumUri || ''}
                  alt="thumbnail"
                  withBorderRadius
                  width="99%"
                  height="98%"
                />
                <Icons.AudioPlay
                  fontSize="large"
                  sx={{
                    position: 'absolute',
                    top: '20%',
                    left: '80%',
                    transform: 'translate(-50%, -50%)',
                    color: 'white',
                  }}
                />
              </>
            )}
          </Box>
        </Link>
      ) : (
        <Box
          sx={{
            width: '99%',
            height: '98%',
            aspectRatio: '1/1',
            position: 'relative',
          }}
          onClick={() => setOpen(true)}
        >
          <ThumbnailImage
            src={
              post.resourceType === PostType.Image
                ? post.imageThumbnail?.blurUri || ''
                : post.resourceType === PostType.Video
                ? post.videoThumbnail?.blurUri || ''
                : ''
            }
            alt="membership_only"
            withBorderRadius
            width="99%"
            height="98%"
          />
          <Icons.MembersOnly
            fontSize="xLarge"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: 'white',
            }}
          />
        </Box>
      )}
      <InformationModal
        open={open}
        onClose={() => setOpen(false)}
        title={
          isGraterPlan
            ? t('viewMemberInfoTitleWithDiff')
            : t('viewMemberInfoTitle')
        }
        content={
          isGraterPlan
            ? t('viewMemberInfoDescWithDiff', {
                planTitle: post.planTitle ?? '',
              })
            : t('viewMemberInfoDesc', { displayName: post.artist.displayName })
        }
        cancelText={t('close')}
        buttons={
          <Button
            size="large"
            color="primary"
            sx={{ minWidth: 212 }}
            href={
              post.artist?.id
                ? generatePath(routerPages.ArtistMembership, {
                    artistId: post.artist.id,
                  })
                : undefined
            }
          >
            {t('seeDetail')}
          </Button>
        }
      />
    </>
  )
}
